<template>
  <el-dialog :close-on-click-modal="false"
             v-bind="$attrs"
             v-on="$listeners"
             :title="title"
             @closed="closed"
             width="600px">
    <div style="margin: 20px 110px 0 80px">
      <el-form label-position="right" label-width="90px" :model="station" :rules="rules" ref="station">
        <input-form-item label="工位名称" prop="name"></input-form-item>
        <remote-form-item label="工位类别" class-name="STATION_TYPE" prop="stationTypeCode" using-code></remote-form-item>
        <remote-form-item label="工位类型" class-name="STATION_CLASS" prop="type" using-code></remote-form-item>
        <input-form-item label="工位面积" prop="area" number></input-form-item>
        <input-number-form-item label="工位数量" prop="workNum"></input-number-form-item>
        <status-form-item label="状态"></status-form-item>
        <textarea-form-item label="备注" prop="remarks"></textarea-form-item>
      </el-form>
    </div>

    <template #footer>
      <el-button v-if="isNew" type="primary" @click="add()">新 增</el-button>
      <el-button v-else-if="!readOnly" type="primary" @click="save()">保 存</el-button>
      <el-button @click="cancel">取 消</el-button>
    </template>
  </el-dialog>
</template>

<script>

  import InputFormItem from '@/components/form/InputFormItem'
  import StatusFormItem from '@/components/form/StatusFormItem'
  import TextareaFormItem from '@/components/form/TextareaFormItem'
  import RemoteFormItem from '@/components/form/RemoteFormItem'
  import InputNumberFormItem from '@/components/form/InputNumberFormItem'
  import { isDouble } from '@/utils/validate'

  export default {
    name: 'EditStationDialog',
    components: {
      InputNumberFormItem,
      RemoteFormItem,
      TextareaFormItem,
      StatusFormItem,
      InputFormItem
    },
    props: {
      station: {
        type: Object,
        required: true
      },
      readOnly: Boolean
    },
    data () {
      return {
        rules: {
          name: [
            {
              required: true,
              message: '请输入工位名称',
              trigger: 'blur'
            }
          ],
          area: [
            {
              validator: (rule, value, callback) => {
                if (!isDouble(value)) {
                  callback(new Error('请输入合法工位面积'))
                } else {
                  callback()
                }
              },
              trigger: 'blur'
            }
          ],
          workNum: [
            {
              required: true,
              message: '请输入工位数量',
              trigger: 'blur'
            }
          ]
        }
      }
    },
    methods: {
      closed () {
        if (!this.readOnly) {
          this.$refs.station.resetFields()
        }
      },
      add () {
        this.$refs.station.validate(valid => {
          if (!valid) return

          this.$store.dispatch('station/add', this.$_.cloneDeep(this.station)).then(() => {
            this.hide()
            this.$message.success('添加成功!')
          })
        })
      },
      save () {
        this.$refs.station.validate(valid => {
          if (!valid) return

          this.$store.dispatch('station/updateOne', this.$_.cloneDeep(this.station)).then(() => {
            this.hide()
          })
        })
      },
      cancel () {
        this.hide()
      },
      hide () {
        this.$emit('update:visible', false)
      }
    },
    computed: {
      isNew () {
        return !this.station.id
      },
      controlReadOnly () {
        return !this.isNew && this.readOnly
      },
      title () {
        if (this.isNew) return '新增工位'
        return this.readOnly ? '查看工位' : '编辑工位'
      }
    }
  }
</script>
